import * as RouterActionTypes from '@medscape-promo/medscapetv/main/main-router/action-types.constants';
import * as PersistentVideoBarActionTypes from '@medscape-promo/medscapetv/main/persistent-video-bar/action-types.constants';
import * as WebViewActionTypes from '@medscape-promo/medscapetv/web-view/action-types.constants';
import MobileDetect from 'mobile-detect';
const md = new MobileDetect(window.navigator.userAgent);

const AdsHandlerMiddleware = (storeAPI) => {

    let adsHandler = null;
    let stickyAdComponent = null;
    return next => action => {
        // Do something in here, when each action is dispatched
        //const state = storeAPI.getState();

        let result = next(action);
        //const nextState = storeAPI.getState();
        //console.log('[MainMiddleware] next state', nextState);
        switch (action.type) {
            case RouterActionTypes.READY:
                (() => {
                    const { BrowserRouter } = action;

                    import('./ads-handler').then(module => {
                        const { default: AdsHandler } = module;
                        const state = storeAPI.getState();
                        const { ads, series } = state.WebView.MedscapeTV;
                        adsHandler = new AdsHandler(storeAPI, ads, series);
                        adsHandler.init(BrowserRouter.history.location);
                    })
                    if (md.mobile() == null && window.breakpoint > 2) {

                        import('./sticky-ad-component').then(module => {
                            const { default: StickyAdComponent } = module;
                            stickyAdComponent = new StickyAdComponent();
                            stickyAdComponent.init();
                        })
                    }
                })()
                break;
            case RouterActionTypes.HISTORY_LOCATION_CHANGE:
                adsHandler.handleRouteChange(action.location.pathname);
                break;
            case PersistentVideoBarActionTypes.INTERSECTION_CHANGE:
                if (stickyAdComponent != null && action.isIntersecting === true) {
                    stickyAdComponent.onPersistentVideoBarChange(false, 0);
                }
                break;
            case PersistentVideoBarActionTypes.ANIMATE:
                if (stickyAdComponent != null) {
                    stickyAdComponent.onPersistentVideoBarChange(true, action.height);
                }
                break;
            case WebViewActionTypes.RESIZE:
                if (stickyAdComponent != null) {
                    stickyAdComponent.checkSticky();
                }
                break;
        }
        return result
    }

}

export default AdsHandlerMiddleware;